import React from 'react';
import PropTypes from 'prop-types';
import { ZCDFlex } from '@zencity/common-ui';
import classNames from 'classnames';
import SentimentSegment from './SentimentSegment';

export const SentimentBar = (props) => {
  const {
    allowComment,
    positive,
    positivePercent,
    mixed,
    mixedPercent,
    neutral,
    neutralPercent,
    negative,
    negativePercent,
  } = props;

  if (!allowComment) {
    return (
      <div className="sentiment-bar">
        <div style={{ textAlign: 'center' }}>Comments Disabled</div>
      </div>
    );
  }

  return (
    <div className="sentiment-bar">
      <ZCDFlex className={classNames('engage-sentiment-analysis-background')} width="100%">
        {positive !== undefined && (
          <SentimentSegment
            foregroundStyle="positive"
            width={positivePercent}
            label="Positive"
            percentage={positivePercent}
            count={positive}
          />
        )}
        {mixed !== undefined && (
          <SentimentSegment
            foregroundStyle="mixed"
            width={mixedPercent}
            label="Mixed"
            percentage={mixedPercent}
            count={mixed}
          />
        )}
        {neutral !== undefined && (
          <SentimentSegment
            foregroundStyle="neutral"
            width={neutralPercent}
            label="Neutral"
            percentage={neutralPercent}
            count={neutral}
          />
        )}
        {negative !== undefined && (
          <SentimentSegment
            foregroundStyle="negative"
            width={negativePercent}
            label="Negative"
            percentage={negativePercent}
            count={negative}
          />
        )}
      </ZCDFlex>
    </div>
  );
};

SentimentBar.propTypes = {
  allowComment: PropTypes.bool.isRequired,
  positive: PropTypes.number.isRequired,
  positivePercent: PropTypes.number.isRequired,
  mixed: PropTypes.number.isRequired,
  mixedPercent: PropTypes.number.isRequired,
  neutral: PropTypes.number.isRequired,
  neutralPercent: PropTypes.number.isRequired,
  negative: PropTypes.number.isRequired,
  negativePercent: PropTypes.number.isRequired,
};

export default SentimentBar;
